import React, { FC } from 'react';
import s from './DesktopPopover.module.scss';

export interface DesktopPopoverProps {
  columns: JSX.Element | null;
  isPopoverOpen?: boolean;
  popoverArrowLeft?: number;
  onClickOverlay: (e: any) => void;
}

const DesktopPopover: FC<DesktopPopoverProps> = ({
  columns,
  isPopoverOpen = false,
  popoverArrowLeft = 380,
  onClickOverlay,
}) => {
  return (
    <div
      id="mph-popover-container"
      data-hook="mph-popover-container"
      className={s.desktopMenu}
    >
      <div
        id="mph-popover-overlay"
        className={`${s.popoverOverlay} ${isPopoverOpen ? s.popoverOpen : ''}`}
        onClick={onClickOverlay}
      >
        <div id="mph-popover" data-hook="mph-popover" className={s.popover}>
          {columns ? (
            <div
              className={s.popoverContent}
              onClick={(e) => e.stopPropagation()}
            >
              {columns}
            </div>
          ) : null}
        </div>
      </div>
      <div
        className={`${s.popoverArrow} ${isPopoverOpen ? s.popoverOpen : ''}`}
        style={{ left: `${popoverArrowLeft}px` }}
      ></div>
    </div>
  );
};

export default DesktopPopover;
